// All of the routes used in the app in one easy to read place.
// By having them as functions, you can pass in props to construct dynamic URLs.
const routes = {
  home: () => "/",
  tool: () => "/go/",
}

export default routes
